import { useEffect, useMemo, useState } from "react"
import clonedeep from "lodash.clonedeep"
import isEqual from "react-fast-compare"
import { useHistory } from "react-router-dom";

const dispatcher = (dispatch, data) => {
	dispatch({ type: "set-common", payload: data })
}

export const useCommon = (local, global = {}, localDispatch, globalDispatch, isInnerPage) => {
	const [current, setCurrent] = useState(global)

	const diferent = !isEqual(local, global)
	const inner = isInnerPage ? 'inner' : 'outer'

	useEffect(() => {
		if (diferent) return; //wait until no diference
		setCurrent(cur => {
			let eq = isEqual(cur, local)
			if (!eq) console.log('common', inner, 'settled', eq, local)
			return eq ? cur : clonedeep(local)
		})
	}, [local, diferent, inner])

	useEffect(() => {
		if (!diferent) return;

		const localModified = !isEqual(local, current)
		const globalModified = !isEqual(global, current)

		const cloned = clonedeep(localModified ? local : global)

		console.log('common', inner, 'changin', localModified, globalModified, local, global, current)

		if (localModified) dispatcher(globalDispatch, cloned)
		else if (globalModified) dispatcher(localDispatch, cloned)
	}, [diferent, localDispatch, globalDispatch, local, global, current, inner])
}
const emptyArr = []

export const useAppHistory = (locationPath, appHistory, dispatch, isInnerPage) => {
	const { go, replace } = useHistory();

	const path = locationPath.toLowerCase()
	const isHomeOrInner = ["", "/", "/home"].includes(path) || isInnerPage;
	const history = appHistory instanceof Array ? appHistory : emptyArr
	const goHome = history.length <= 1;

	useEffect(() => {
		if (isInnerPage) return;
		if (history.at(-1) === path) return;

		console.log("setting up history", path)
		dispatch({ type: "set", payload: { history: isHomeOrInner ? emptyArr : [...history, path] } })

	}, [path, isHomeOrInner, history, dispatch, isInnerPage])

	return useMemo(() => isHomeOrInner ? null : goHome ? () => replace("/") : () => go(-1), [isHomeOrInner, goHome, go, replace])
}


export const mergeCommon = (_data, common) => {
	const data = _data || {}
	data.common = common || {}
	return data
}


export default useCommon;
